export const ATTACK = 'ATTACK';
export const ATTACK_END = 'ATTACK_END';
